import { Injectable } from '@angular/core';
import { Provider } from '../provider';
import { INotification } from 'src/app/models/notification.model';

@Injectable()
export class OrganisationNotificationService extends Provider<INotification> {
  protected url = "common/notifications";
}
 